// @ts-check
// Situação de quem atende no topo da Caixa (contrato 10 de atendimento, seção 8.1): Disponível, Ausente, Fora do horário.
// Só quem está Disponível recebe atendimentos pela distribuição; ficar Disponível distribui o que espera na fila.
import { html } from 'htm/preact';
import { useRef, useState } from 'preact/hooks';
import { setAgentStatus } from '../../data/service-desk.js';
import { AGENT_STATUSES } from '../../../../shared/service-desk/ticket-values.js';
import { Dropdown, DropdownMenuItems, MenuItem } from '../../ui/dropdown.js';
import { Icon } from '../../ui/icon.js';
import { showSuccessSnackbar } from '../../ui/snackbar.js';
import { showServiceError } from './service-display.js';
import { t } from '../../i18n/index.js';

/** @param {{ status: string }} props */
export function AgentStatusDot({ status }) {
  return html`<span class="service-agent-dot" data-status=${status} aria-hidden="true"></span>`;
}

/**
 * @param {{ status: 'AVAILABLE' | 'AWAY' | 'OFFLINE' | null, onChanged: (status: 'AVAILABLE' | 'AWAY' | 'OFFLINE') => void }} props
 */
export function AgentStatusMenu({ status, onChanged }) {
  const anchorRef = useRef(/** @type {HTMLButtonElement | null} */ (null));
  const [isOpen, setIsOpen] = useState(false);
  const current = status ?? 'OFFLINE';
  /** @param {'AVAILABLE' | 'AWAY' | 'OFFLINE'} next */
  const choose = async (next) => {
    setIsOpen(false);
    try {
      const saved = await setAgentStatus(next);
      onChanged(saved ?? next);
      showSuccessSnackbar(t('serviceDesk.agentStatus.changed', { status: t(`serviceDesk.agentStatus.${next}`) }));
    } catch (error) {
      showServiceError(error);
    }
  };
  return html`<span class="service-agent-status">
    <button type="button" ref=${anchorRef} class="service-agent-button" aria-haspopup="menu" aria-expanded=${isOpen ? 'true' : 'false'}
      data-testid="service-agent-status" title=${t('serviceDesk.agentStatus.title')} onClick=${() => setIsOpen(!isOpen)}
      aria-label=${`${t('serviceDesk.agentStatus.title')}: ${t(`serviceDesk.agentStatus.${current}`)}`}>
      <${AgentStatusDot} status=${current} /><span class="service-agent-label">${t(`serviceDesk.agentStatus.${current}`)}</span><${Icon} name="IconChevronDown" size=${12} />
    </button>
    <${Dropdown} anchorRef=${anchorRef} isOpen=${isOpen} onClose=${() => setIsOpen(false)} width=${240} placement="bottom-end" role="menu">
      <${DropdownMenuItems}>
        ${AGENT_STATUSES.map((value) => html`<${MenuItem} key=${value} text=${t(`serviceDesk.agentStatus.${value}`)} selected=${value === current}
          leftComponent=${html`<${AgentStatusDot} status=${value} />`} contextualText=${t(`serviceDesk.agentStatus.hints.${value}`)} onClick=${() => choose(value)} />`)}
      <//>
    <//>
  </span>`;
}
